module.exports = __webpack_public_path__ + "static/media/upload.a2eaa453.svg";